<form nz-form [formGroup]="_fS.addInvestorForm">
    <div [ngClass]="!IsDrawer ? 'investor-drawer' : 'investors-modal-box'">
        <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }" class="ml-0 mr-0">
            <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24" class="pl-0">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="companyNameError">
                        <label class="label-text required">Company name</label>
                        <input class="input-group" nz-input formControlName="companyName" minlength="2" maxlength="100"
                            placeholder="Enter company name" />
                        <ng-template #companyNameError let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter company name</ng-container>
                            <ng-container *ngIf="control.hasError('minlength')">Company must contain at least 2
                                characters
                            </ng-container>
                            <ng-container *ngIf="control.hasError('pattern')">Please enter company name
                            </ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <nz-collapse nzGhost class="form-collapse-custom-panel p-0">
            <nz-collapse-panel [nzHeader]="'Add Address'" [nzActive]="isAddAddressClicked"
                (nzActiveChange)="addAddressInvestor($event)" class="p-0">
                <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }" class="ml-0 mr-0">

                    <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24" class="mb-1"
                        [ngClass]="isInternationalClicked ? 'mt-1':'mb-1'">
                        <div class="right">
                        <span class="mr-1 fs-14">Domestic</span>
                        <nz-switch [(ngModel)]="isInternationalClicked"
                            (ngModelChange)="addInternationalClicked($event)"
                            [ngModelOptions]="{standalone: true}" nzSize="small"></nz-switch>
                        <span class="ml-1 fs-14">International</span>
                    </div>
                    </div>

                    <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12" class="pl-0">
                        <nz-form-item *ngIf="!isInternationalClicked">
                            <nz-form-control [nzErrorTip]="address1Error">
                                <label class="label-text">Address 1</label>
                                <input class="input-group" nz-input formControlName="streetAddress1" minlength="2"
                                    maxlength="100" placeholder="Enter address 1">

                                <!-- <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24"> -->
                                <!-- <div (click)="addInternationalClicked(!isInternationalClicked)" class="cursor fs-14">
                                    <span nz-icon class="pr-12 fs-12" [nzType]="isInternationalClicked ? 'up' :'down'"
                                        nzTheme="outline"></span>International
                                </div> -->
                                <!-- </div> -->
                                <ng-template #address1Error let-control>
                                    <ng-container *ngIf="control.hasError('required')">Please enter address
                                        1</ng-container>
                                    <ng-container *ngIf="control.hasError('minlength')">Address must contain at
                                        least 2
                                        characters
                                    </ng-container>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>

                    <div *ngIf="!isInternationalClicked" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                        <nz-form-item>
                            <nz-form-control [nzErrorTip]="address2Error">
                                <label class="label-text">Address 2</label>
                                <input class="input-group" nz-input formControlName="streetAddress2" minlength="2"
                                    maxlength="100" placeholder="Enter address 2" />
                                <ng-template #address2Error let-control>
                                    <ng-container *ngIf="control.hasError('required')">Please enter address
                                        2</ng-container>
                                    <ng-container *ngIf="control.hasError('minlength')">Address must contain at
                                        least 2
                                        characters
                                    </ng-container>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>

                    <div *ngIf="isInternationalClicked" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24"
                        class="pl-0">
                        <nz-form-item class="mb-0">
                            <nz-form-control [nzErrorTip]="address1Error">
                                <label class="label-text">International address</label>
                                <textarea class="input-group" nz-input rows="4" formControlName="streetAddress1"
                                    minlength="2" maxlength="255" placeholder="Enter international address"></textarea>
                                <!-- <div (click)="addInternationalClicked(!isInternationalClicked)" class="cursor"><span
                                        nz-icon [nzType]="'down'" nzTheme="outline" class="pr-12 fs-12"></span>US
                                    Address
                                </div> -->
                                <ng-template #address1Error let-control>
                                    <ng-container *ngIf="control.hasError('required')">Please enter International
                                        address
                                    </ng-container>
                                    <ng-container *ngIf="control.hasError('minlength')">International address must
                                        contain at
                                        least 2
                                        characters
                                    </ng-container>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>




                    <div *ngIf="!isInternationalClicked" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12"
                        class="pl-0">
                        <nz-form-item>
                            <nz-form-control [nzErrorTip]="cityError">
                                <!-- required -->
                                <label class="label-text">City / Town</label>
                                <input class="input-group" nz-input formControlName="city" minlength="2" maxlength="100"
                                    (keypress)="_cS.checkAlphabetsWithSpace($event)" placeholder="Enter city" />
                                <ng-template #cityError let-control>
                                    <ng-container *ngIf="control.hasError('minlength')">City must contain atleast 2
                                        characters</ng-container>
                                    <ng-container *ngIf="control.hasError('required')">Please select city</ng-container>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div *ngIf="!isInternationalClicked" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                        <nz-form-item>
                            <nz-form-control [nzErrorTip]="StateError">
                                <label class="label-text">State</label>
                                <nz-select nzShowSearch nzPlaceHolder="Select state" [nzSize]="'default'"
                                    formControlName="state" [nzSelectOnTab]="true">
                                    <nz-option *ngFor="let state of listOfStates" [nzLabel]="state"
                                        [nzValue]="state"></nz-option>
                                </nz-select>
                                <ng-template #StateError let-control>
                                    <ng-container *ngIf="control.hasError('required')">Please select
                                        state</ng-container>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div *ngIf="!isInternationalClicked" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12"
                        class="pl-0">
                        <nz-form-item>
                            <nz-form-control [nzErrorTip]="zipCodeError">
                                <label class="label-text">Zip code</label>
                                <input #zipCode autocomplete="off" class="input-group"
                                    (keypress)="_cS.checkNumbers($event)" minlength="5" nz-input
                                    formControlName="zipCode" name="zipCode" maxlength="12" mask="00000||00000-0000"
                                    placeholder="Enter zip code" />
                                <ng-template #zipCodeError let-control>
                                    <ng-container *ngIf="control.hasError('required')">Please enter
                                        zipcode</ng-container>
                                    <ng-container *ngIf="control.hasError('minlength')">Zip code must contain at least 5
                                        digits
                                    </ng-container>
                                    <ng-container
                                        *ngIf="_fS.addVendorForm.get('zipCode').value.length > 5 && _fS.addVendorForm.get('zipCode').value.length < 9">Please
                                        enter valid zipcode (XXXXX-XXXX or XXXXX)
                                    </ng-container>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div *ngIf="!isInternationalClicked" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                        <nz-form-item>
                            <nz-form-control [nzErrorTip]="countryError">
                                <label class="label-text">Country</label>
                                <input value="USA" formControlName="country" nz-input>
                                <ng-template #countryError let-control>
                                    <ng-container *ngIf="control.hasError('required')">Please enter
                                        country</ng-container>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>


                </div>
            </nz-collapse-panel>

        </nz-collapse>
        <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }" class="ml-0 mr-0"
            [ngClass]="isAddAddressClicked ? '' : 'pt-20'">
            <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12" class="pl-0">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="firstNameError">
                        <label class="label-text required">First name</label>
                        <input class="input-group" nz-input formControlName="firstName"
                            (keypress)="_cS.checkAlphabets($event)" minlength="2" maxlength="100"
                            placeholder="Enter first name" />
                        <ng-template #firstNameError let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter first name</ng-container>
                            <ng-container *ngIf="control.hasError('minlength')">First must contain at least 2
                                characters
                            </ng-container>
                            <ng-container *ngIf="control.hasError('pattern')">Please enter first name
                            </ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="lastNameError">
                        <label class="label-text required">Last name</label>
                        <input class="input-group" nz-input formControlName="lastName"
                            (keypress)="_cS.checkAlphabets($event)" minlength="2" maxlength="100"
                            placeholder="Enter last name" />
                        <ng-template #lastNameError let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter last
                                name</ng-container>
                            <ng-container *ngIf="control.hasError('minlength')">Last name must contain at least 2
                                characters
                            </ng-container>
                            <ng-container *ngIf="control.hasError('pattern')">Please enter last name
                            </ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12" class="pl-0">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="emailAddressError">
                        <label class="label-text required">Email address</label>
                        <input class="input-group" nz-input formControlName="emailAddress"
                            pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}"
                            placeholder="Enter email address" />
                        <ng-template #emailAddressError let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter email address
                            </ng-container>
                            <ng-container *ngIf="control.hasError('pattern')">Enter valid email address
                            </ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="phoneError">
                        <label class="label-text">Mobile number</label>
                        <input class="input-group" nz-input formControlName="phoneNumber"
                            (keypress)="_cS.checkNumbers($event)" mask="(000) 000-0000" pattern="\d{10}"
                            placeholder="Enter mobile number">
                        <ng-template #phoneError let-control>
                            <ng-container *ngIf="control.hasError('pattern')">
                                Mobile number must contain at least 10 digits
                            </ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
    </div>
</form>

<div class="d-flex justify-content-end footer-box">
    <button nz-button nzType="default" (click)="handleCancel(null)" class="default-btn width-100 mr-1">Cancel</button>
    <button nz-button nzType="primary" (click)="handleOk()" class="medium-btn small-btn width-100 mr-0 "
        [nzLoading]="isAddingInvestor">Create</button>
</div>